import { lazy } from 'react';
import type { AppModule } from '../core/module';

/**
 * 모듈 등록 배열. 새 모듈 = import(lazy) 한 줄 + 이 배열에 한 줄.
 * 라우터와 하단 네비가 이 배열을 읽어 자동 생성된다.
 * adminOnly 모듈은 어드민에게만 네비/라우트에 노출된다.
 */
export const modules: AppModule[] = [
  {
    id: 'home',
    title: '홈',
    icon: 'Home',
    route: '/',
    navOrder: 0,
    showInBottomNav: true,
    Component: lazy(() => import('./home/HomePage')),
  },
  {
    id: 'roulette',
    title: '룰렛',
    icon: 'Dices',
    route: '/roulette',
    navOrder: 10,
    // 자주 쓰는 결정 도구라 하단탭으로(home·룰렛·편지함·유령체스·대화분석 5탭).
    showInBottomNav: true,
    Component: lazy(() => import('./roulette/RoulettePage')),
  },
  {
    id: 'letters',
    title: '편지함',
    icon: 'Mail',
    route: '/letters',
    navOrder: 20,
    showInBottomNav: true,
    Component: lazy(() => import('./letters/LettersPage')),
  },
  {
    id: 'chess',
    title: '유령체스',
    icon: 'Ghost',
    route: '/chess',
    navOrder: 40,
    showInBottomNav: true,
    Component: lazy(() => import('./chess/ChessPage')),
  },
  {
    id: 'chat-stats',
    title: '대화분석',
    icon: 'MessageCircle',
    route: '/chat-stats',
    navOrder: 50,
    showInBottomNav: true,
    Component: lazy(() => import('./chat-stats/ChatStatsPage')),
  },
  {
    id: 'admin',
    title: '설정',
    icon: 'Settings',
    route: '/admin',
    navOrder: 90,
    showInBottomNav: false,
    adminOnly: true,
    Component: lazy(() => import('./admin/AdminPage')),
  },
];

export function visibleModules(isAdmin: boolean): AppModule[] {
  return modules
    .filter((m) => !m.adminOnly || isAdmin)
    .sort((a, b) => a.navOrder - b.navOrder);
}
